export function setCSSVariable(name: string, value: string) {
  document.documentElement.style.setProperty(name, value)
}
